import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

// Shared blue info/callout banner. Used for the Instagram-analysis progress
// note and the "couldn't find much" note on a thin competitor card so the two
// can't drift in shape.
export function InfoBanner({
	children,
	icon,
	className,
}: {
	children: ReactNode;
	icon?: ReactNode;
	className?: string;
}) {
	return (
		<div
			className={cn(
				'flex items-center gap-3 rounded-xl bg-blue-50 p-4 text-blue-600',
				className,
			)}
		>
			{icon}
			{children}
		</div>
	);
}
